export const planKeys = {
    modules: {
        PSYCHO_QUIZ: 'promotionPsychologicalTest',
        SIGN_FORM: 'promotionRegistration',
        QUIZ: 'promotionQuiz',
        SURVEY: 'promotionSurvey',
        WIN_WHEEL: 'promotionRoulette',
        VOTE: 'promotionIssueVote',
        POKE_GAME: 'promotionPoke',
        SCRATCH_CARD: 'promotionScratchCard',
        INVOICE: 'promotionInvoiceTW',
        RED_ENVELOPE_RAIN: 'promotionRedEnvelope',
        PHOTO_UPLOAD: 'promotionImageUpload',
        CHECK_IN: 'promotionCheckIn',
        CONTEST_PHOTO_UPLOAD: 'promotionPhotoContest',
        PHOTO_FRAME_COMPOSITE: 'promotionCreativeFrame',
        SLOTS: 'promotionSlot',
        PICK_THE_PRIZE: 'promotionPickThePrize',
        MEMORY_MATCH: 'promotionMemoryMatch',
        COMMENT: 'promotionComment',
        CONTEST_ADMIN_UPLOAD: 'promotionVotingContest',
        CONTEST_PHOTO_FRAME_COMPOSITE: 'promotionFramedPhotoContest',
        CHALLENGE_PHOTO_FRAME_COMPOSITE: 'promotionPhotoChallenge',
        VIDEO_UPLOAD: 'promotionVideoUpload',
        CONTEST_VIDEO_UPLOAD: 'promotionVideoContest',
        PURCHASE_REWARD: 'promotionPurchaseReward',
        POINTS_REDEEM: 'promotionPointsRedeem',
        MGM_SHARE: 'promotionMGMShare',
        SIGN_UP: 'promotionSignUp',
        MULTI_CHALLENGE: 'promotionMultiChallenge',
        ORDER_REWARD: 'promotionOrderReward',
        CART_REWARD: 'promotionCartReward',
        MISSION_REWARD_BY_STAFF: 'promotionMissionRewardByStaff',
        AI_WEB_GAME_SCORING_CUSTOM: 'promotionAIGame',
        GIFT_CATCHER: 'promotionGiftCatcher',
        MAGIC_CUP: 'promotionMagicCup',
        MATCH3_BREAKER: 'promotionMatch3Breaker',
        RUN_TO_FUTURE: 'promotionRunToFuture',
        TOTAL_RESCUE: 'promotionTotalRescue',
        HIGHWAY_DODGE: 'promotionHighwayDodge',
        AI_WEB_GAME_GASHAPON: 'promotionGashapon',
        AI_WEB_GAME_LOTTERY_CUSTOM: 'promotionAILottery',
        AI_WEB_GAME_GARAPON: 'promotionGarapon'
    },
    lotteries: {
        JOIN_AND_GET: 'lotteryParticipant',
        SCRATCH_CARD: 'lotteryScratchCard',
        WIN_WHEEL: 'lotteryRoulette',
        POKE_GAME: 'lotteryPoke',
        RED_ENVELOPE_RAIN: 'lotteryRedEnvelope',
        SLOTS: 'lotterySlot',
        PICK_THE_PRIZE: 'lotteryPickThePrize',
        ADMIN: 'lotteryAdmin',
        POINTS_REDEEM: 'lotteryPointsRedeem',
        CUSTOM_HTML: 'lotteryCustomHTML',
        GASHAPON: 'lotteryGashapon',
        GARAPON: 'lotteryGarapon'
    },
    login: {
        ANONYMOUS: 'anonymousLogin',
        FACEBOOK: 'facebookLogin',
        LINE: 'lineLogin',
        ENTERPRISE: 'enterpriseLogin'
    },
    qualify: {
        LIMITATION: 'entryRules',
        LOCATION: 'enabledQualificationLocation'
    },
    purchaseReward: {
        PURCHASE_REWARD_AUTO_ENTRY: 'enablePurchaseRewardAutoEntry'
    },
    entries: {
        DAILY_PLAY_TIMES: 'dailyPlayTimes',
        TOTAL_PLAY_TIMES: 'totalPlayTimes',
        PERIOD_PLAY_MODE: 'periodPlayMode'
    },
    prizes: {
        PRIZE_VIRTUAL_NUMBER: 'prizeVirtualNumber'
    },
    form: {
        FORM_REDIRECT: 'formRedirect',
        SIGNUP_FORM_LIMIT: 'formSignUp'
    },
    tags: {
        TAGGED_BY_PROMO: 'taggedByPromotion'
    },
    webhook: {
        API_WEBHOOK: 'apiWebhook'
    }
};

export const planTypes = {
    PROMO_PLAN: 1,
    POINT_PLAN: 2
};
